import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import canUseDom from '@nebula/can-use-dom';
export var SUPPORT_CSS_VARS = function () {
  if (!canUseDom()) return true;
  var testEl = document.createElement('a');
  try {
    testEl.style.setProperty('--x', 'x');
    return testEl.style.getPropertyValue('--x') === 'x';
  } catch (e) {
    return false;
  }
}();
export default function loadThemePolyfillIfNeeded() {
  return _loadThemePolyfillIfNeeded.apply(this, arguments);
}
function _loadThemePolyfillIfNeeded() {
  _loadThemePolyfillIfNeeded = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var imports, imported, mutationObserver, cssVarsPonyfill;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            imports = [Promise.resolve(), Promise.resolve()];
            if (!window.MutationObserver) {
              imports[0] = import('./mutationObserver');
            }
            if (!SUPPORT_CSS_VARS) {
              imports[1] = import('css-vars-ponyfill');
            }
            _context.next = 5;
            return Promise.all(imports);
          case 5:
            imported = _context.sent;
            mutationObserver = imported[0];
            cssVarsPonyfill = imported[1];
            if (mutationObserver) mutationObserver.default();
            if (cssVarsPonyfill) cssVarsPonyfill.default({
              preserveVars: true,
              watch: true
            });
          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadThemePolyfillIfNeeded.apply(this, arguments);
}